// Security-aware middleman sitting between your app and the server
//`injects your Bearer token into requests, tracks them so they can be aborted on logout, 
// and dispatches an `auth:unauthorized` event when a `401` is returned so the app can immediately log the user out. 
import { getTokens } from '../auth/authUtils';

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

const requestControllers = new Set<AbortController>();

export function abortAllRequests(): void {
  requestControllers.forEach((controller) => controller.abort());
  requestControllers.clear();
}

export async function authFetch(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const tokens = getTokens();
  if (!tokens?.access_token) {
    throw new Error('NOT_AUTHENTICATED');
  }

  const controller = new AbortController();
  requestControllers.add(controller);

  try {
    const response = await fetch(input, {
      ...init,
      signal: controller.signal,
      headers: {
        ...(init.headers ?? {}),
        Authorization: `Bearer ${tokens.access_token}`,
      },
    });

    if (response.status === 401) {
      window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
      throw new Error('UNAUTHORIZED');
    }

    return response;
  } finally {
    requestControllers.delete(controller);
  }
}
